module.exports = __webpack_public_path__ + "files/d5419f6d92a3839bf493e1c024168910.png";